import { Input } from "@frui.ts/bootstrap";
import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import { CheckArray } from "controls/checkArray";
import FormLabel from "controls/formLabel";
import FormGroup from "controls/formGroup";
import UserCreateViewModel from "../../../viewModels/users/users/userCreateViewModel";
import CreateView from "../../common/create";
import UserForm from "./userForm";

const UserCreateView: ViewComponent<UserCreateViewModel> = observer(({ vm }) => {
  const form = (
    <UserForm vm={vm}>
      <Form.Row>
        <Form.Group as={Col} md={6}>
          <FormLabel target={vm.item} property="allowedProviders">
            {vm.translate("externalProvider")}
          </FormLabel>
          <Form.Row>
            {vm.externalIdentityProviderOptions.map(provider => (
              <Col sm="auto" key={provider.id}>
                <CheckArray
                  custom
                  key={provider.id}
                  target={vm.item}
                  property="allowedProviders"
                  id={provider.id.toString()}
                  label={provider.label}
                />
              </Col>
            ))}
          </Form.Row>
        </Form.Group>
      </Form.Row>
      {vm.hasExternalProviders ? (
        <Form.Row>
          <FormGroup as={Col} md={6} target={vm} property="invitationDays">
            <FormLabel>{vm.translate("invitationValidity")}</FormLabel>
            <Input type="number" errorMessage={vm.invitationDaysError} />
          </FormGroup>
        </Form.Row>
      ) : (
        <Form.Row>
          <FormGroup as={Col} className="col-md-6" target={vm.item} property="username">
            <FormLabel>{vm.translateAttribute("username")}</FormLabel>
            <Input />
          </FormGroup>
        </Form.Row>
      )}
    </UserForm>
  );

  return <CreateView vm={vm} form={form} />;
});

registerView(UserCreateView, UserCreateViewModel);
